export default "__VITE_ASSET__DQYmnb0N__"